import React from "react";

import Container from "./Container";
import TopNav from "./TopNav";
import BottomNav from "./BottomNav";

export default ({ title, maxWidth = "sm", children, noBottomNav }) => {
  return (
    <div style={{ padding: "50px 0 60px" }}>
      <TopNav title={title} />
      <Container maxWidth={maxWidth}>{children}</Container>
      {!noBottomNav && <BottomNav />}
    </div>
  );
};
